var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-page-header',{attrs:{"icon":"fa fa-user","title":"Alunos","breadcrumbs":[
            { href: '/', title: 'Painel' },
            { href: '', title: 'Alunos' }
        ]}}),_vm._v(" "),_c('app-datatable',{ref:"dataTable",attrs:{"entity":"students","allow-enable-multi":_vm.allows.enableMulti,"allow-disable-multi":_vm.allows.disableMulti,"allow-delete-multi":_vm.allows.deleteMulti,"statusFilterIndex":5,"options":{
            ajax: {
                url: '/web/students'
            },
            columns: _vm.columns
        },"actions":{
            qrcode: {
                allow: _vm.allows.qrcode,
                url: '/students/print_qrcode?student_id=*'
            },
            pass: {
                allow: _vm.allows.pass,
                url: '/students/print_password?student_id=*',
            },
            create: {
                allow: _vm.allows.create,
                url: '/students/create'
            },
            show: {
                allow: _vm.allows.show,
                url: '*',
                callback: _vm.onShow
            },
            edit: {
                allow: _vm.allows.edit,
                url: '/students/*/edit',
            },
            delete: {
                allow: _vm.allows.delete,
                url: '*'
            },
        },"filters":[
            {
                name: 'school_id',
                type: 'select',
                label: 'Escola',
                index: 6,
                options: _vm.schools,
                liveSearch: true,
                callback: _vm.loadClassrooms,
            },
            {
                name: 'classroom_id',
                type: 'select',
                label: 'Sala',
                index: 7,
                options: [],
                liveSearch: true,
            },
            {
                name: 'responsible_id',
                type: 'select',
                label: 'Responsável',
                index: 8,
                options: _vm.responsibles,
                liveSearch: true,
            },
            {
                name: 'type',
                type: 'select',
                label: 'Tipo de Aluno',
                index: 9,
                options: [
                    { value: 'classroom', label: 'Com Sala'},
                    { value: 'responsible', label: 'Com Responsável'},
                ]
            }
        ]}}),_vm._v(" "),_c('app-student-show',{ref:"studentShow"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }